import { API_BASE_URL } from './axios';

/**
 * Render pulsuz planda backend 15 dəqiqə hərəkətsizlikdən sonra yatır və
 * oyanmağa ~1 dəqiqə sərf edir.
 *
 * Frontend Static Site-dır — o, dərhal açılır. Ona görə səhifə yüklənən
 * kimi backend-ə "oyan" siqnalı göndəririk. İstifadəçi hero bölməsini
 * oxuyarkən server arxa planda oyanır və məhsullara çatanda hazır olur.
 *
 * Cavabı gözləmirik, xətanı udurıq — bu, sadəcə tətikdir.
 */
export const warmUpBackend = () => {
  if (typeof window === 'undefined') return;

  try {
    fetch(`${API_BASE_URL}/health`, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      keepalive: true,
    }).catch(() => {
      // Server yatıbsa bu sorğu düşəcək — normaldır, məqsəd onu oyatmaqdır
    });
  } catch (e) {
    // sükutla keç
  }
};

export default warmUpBackend;
